import businessClient from 'src/services/clients/business'

import { IMeta, ILocation, ISetLocation } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { url: '', endpoint: '' } }

export const integrationBolt = {
  /**
   * @return {Promise<IResponse>}
   */
  pairSystem(data, signal) {
    return businessClient().post('apppair/bolt/pair/business', { data }, { signal })
  },

  /**
   * @return {Promise<IResponse>}
   */
  disconnect(signal) {
    return businessClient().post('apppair/bolt/disconnect/business', {}, { signal })
  },

  /**
   * @param {{ store_id: number, bolt_store_id: string, bolt_store_name: string }} data
   * @return {Promise<IResponse>}
   */
  pairStore(data, signal) {
    return businessClient().post('apppair/bolt/pair/store', { data }, { signal })
  },

  /**
   * @param {{store_id: number, auto_accept_minute: number }} data
   * @return {Promise<IResponse>}
   */
  autoAccept(data, signal) {
    return businessClient().post('apppair/bolt/auto-accept', { data }, { signal })
  },
}
